import { Footer } from "@/components/landing/footer";
import { Navbar } from "@/components/landing/navbar";

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_web/_layout")({
  component: Layout,
  notFoundComponent: ({ data }) => {
    return <div>Page Not Found</div>;
  },
});

function Layout() {
  return (
    <div className="min-h-screen bg-white scroll-smooth">
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
}
